/**
 * ZAdminEmailWatch - Shared email watch setup types
 *
 * Single source of truth for email watch setup detail used by both Gmail and Outlook
 * admin operations. Extracted to eliminate duplication between zadmin-gmail.ts and
 * zadmin-outlook.ts (DRY fix).
 */

import { z } from "zod";

/**
 * Schema for a single deployment's watch setup result.
 *
 * Shared between Gmail (setup-watches) and Outlook (setup-watches) admin operations.
 */
export const WatchSetupDetailSchema = z.object({
  /** Deployment ID */
  id: z.string().uuid(),
  /** Deployment name */
  name: z.string(),
  /** Setup status */
  status: z.enum(["success", "skipped", "failed"]),
  /** Provider subscription ID (if successful or skipped with existing) */
  subscriptionId: z.string().optional(),
  /** Error message (if failed) */
  error: z.string().optional()
});

/** Individual watch setup result */
export type WatchSetupDetail = z.infer<typeof WatchSetupDetailSchema>;
